/*********************************************************************************************
* Active container
	*
*/
document.addEventListener("DOMContentLoaded", function() {
	// Pour chaque section FAQ sur la page
	document.querySelectorAll(".mm-page-faq").forEach(function(section) {
		const filters = section.querySelectorAll(".mm-page-faq-tabs-title");
		const faqContents = section.querySelectorAll(".mm-faq-dropdown");

		if (filters.length > 0 && faqContents.length > 0) {
			filters[0].classList.add("active");
			faqContents[0].classList.add("active");
		}

		filters.forEach((filter, index) => {
			filter.addEventListener("click", function() {
				filters.forEach(f => f.classList.remove("active"));
				faqContents.forEach(content => content.classList.remove("active"));

				filter.classList.add("active");
				faqContents[index].classList.add("active");
			});
		});
	});
});

/*********************************************************************************************
* Splide tabs
    *
*/
document.addEventListener('DOMContentLoaded', function () {
    const routineSections = document.querySelectorAll('[data-section-page-faq-id]');
    let scrollCounter = 0;
    
    routineSections.forEach(function (section) {
        const id = '.mm-page-faq-tabs-splide';
        const splideElem = section.querySelector(id);
    
        if (splideElem !== null && splideElem.querySelectorAll(".splide__slide").length > 0) {
            mmSplideInit(splideElem, section);
        }
    });

    function mmSplideInit(splideElem, section) {
        var splideInstance = new Splide(splideElem, {
            type        : 'slide',
            arrows      : false,
            pagination  : false,
            gap         : '12px',
            fixedWidth  : 'fit-content',
            perMove     : 1,
            destroy: true,
            padding     : {
            },
            breakpoints : {
                990: {
                    destroy: false,
                }
            }
        }).mount();

        // Ajoute l'écouteur d'événement de défilement à splideElem
        splideElem.addEventListener('wheel', function (e) {
            // Ne pas empêcher le comportement par défaut si le défilement est vertical
            if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) {
                return;
            }

            // Empêche le comportement par défaut uniquement pour le défilement horizontal
            e.preventDefault();

            // Incrémente le compteur de défilements
            scrollCounter++;

            // Vérifie si le compteur atteint le seuil pour un mouvement
            if (scrollCounter >= 12) {
                // Réinitialise le compteur
                scrollCounter = 0;

                // Déplace la diapositive selon la direction du défilement horizontal
                if (e.deltaX < 0) {
                    splideInstance.go('<'); // Mouvement vers la gauche
                } else if (e.deltaX > 0) {
                    splideInstance.go('>'); // Mouvement vers la droite
                }
            }
        });
    }
});
